import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {DeliveryRatingsReportRecord} from './delivery-rate.record';

export class DeliveryRateReportCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/reports/rateDeliveryReport';

    async loadDeliveryRate(): Promise<any> {
        return httpService
            .get(this.apiPath, {transformResponse: (data: any) => new Function(' return ' + data)()})
            .then((response) => response.data.reportRecords);
    }

    exportReport(fileName: string): Window {
        const url: string =
            httpService.getBaseUrl() +
            '/gt/gt-api/reports/rateDeliveryReport/' +
            Date.now() +
            '/?type=Excel&fileName=' +
            fileName;
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
